const state = {

  period: null,

}


const getters = {

  period: state => state.period,

}


const mutations = {

  setPeriod (state, period) {
    state.period = period
  },


}


const actions = {


}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}